<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="text-align:center">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id" :style="body['isRead'] == '0' ? 'font-weight:600;background: rgba(232, 232, 232, 1)': ''">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions'">
                                            <template v-if="item == 'Subjek'">
                                                <span :title="body['perihal']"><span class="font-weight-bold mr-2">{{body['jenisSurat']}}</span>{{body['perihal']}}</span>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'listLampiran'">
                                                    <CRow>
                                                        <CCol sm="6" v-for="(pdf, ids) in body['listLampiran']" :key="ids">
                                                            <img class="mr-2" :src="downloadIcon" @click="direct(id, ids)" width="20px" height="20px" style="cursor:pointer"/>
                                                        </CCol>
                                                    </CRow>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'urlSurat'">
                                                        <img class="mr-2" :src="downloadIcon" @click="show(id)" width="20px" height="20px" style="cursor:pointer"/>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'statusAction'">
                                                            <span v-if="body['action'] == 'D'">Draft</span>
                                                            <span v-if="body['action'] == 'S' && body['status'] == 'P'">On Progress</span>
                                                            <span v-if="body['action'] == 'S' && body['status'] == 'R'">Rejected</span>
                                                            <span v-if="body['action'] == 'S' && body['status'] == 'S'">Sent</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'dataAksi'">
                                                                {{body['action']}}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'internal'">
                                                                    {{ body['internal'] == '1' ? 'Internal' : 'Eksternal' }}
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="item == 'isUploaded'">
                                                                        <span class="badge text-white bg-success" v-if="body['isUploaded'] == '2'">Sudah Upload Surat</span>
                                                                        <span class="badge text-white bg-danger" v-else>Belum Upload Surat</span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <template v-if="item == 'listKepada'">
                                                                            <li v-for="(ol, listIndex) in body['listKepada']" :key="listIndex">
                                                                                {{ ol.nama }}
                                                                            </li>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span :title="body[item]">{{body[item] == null || body[item] == 'null' ? '-' : body[item] }}</span>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                            <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item == 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                            <CButton v-if="body['action'] == 'D'" @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                            <CButton v-if="body['action'] == 'S'" @click="goEdit(id)" class="btn my-1 btn-edit mr-1">Detail</CButton>
                                            <CButton v-if="body['action'] == 'D'" @click="goDelete(id)" class="btn my-1 btn-edit mr-1">Delete</CButton>
                                            <CButton @click="goPreview(id)" class="btn my-1 btn-edit mr-1">Preview</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item != 'act' && item == 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                            <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Action</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item != 'act' && item != 'actions' && item == 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                            <CButton v-if="body['edit'] == 'T'" @click="goEdit(id)" class="btn my-1 btn-edit">View</CButton>
                                            <CButton v-if="body['edit'] == 'Y'" @click="goEdit(id)" class="btn my-1 btn-edit">Action</CButton>
                                            <CButton @click="goPreview(id)" class="btn my-1 btn-edit mr-1">Preview</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item == 'disposition' && item != 'dispositions' && item != 'upload'">
                                            <CButton @click="goEdit(id)" class="btn my-1 btn-edit-disposition">Disposition</CButton>
                                            <CButton @click="goHistory(id)" class="btn my-1 btn-edit mr-1">History</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item == 'dispositions' && item != 'upload'">
                                            <CButton v-if="body['action'] == 'S' && body['internal'] == '1'" @click="goDisposition(id)" class="btn my-1 btn-edit-1">Disposition</CButton>
                                            <CButton v-if="body['action'] == 'D'" @click="goEdit(id)" class="btn my-1 btn-edit-1">Edit</CButton>
                                            <CButton v-if="body['action'] == 'S'" @click="goPreview(id)" class="btn my-1 btn-edit-1 mr-1">Surat (QR Code)</CButton>
                                            <CButton v-if="body['action'] == 'S' && body['internal'] != '1'" @click="goPreviewSignature(id)" class="btn my-1 btn-edit-1 mr-1">Surat (Signature)</CButton>
                                            <CButton v-if="body['action'] == 'S'" @click="goEdit(id)" class="btn my-1 btn-edit-1 mr-1">Detail</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item == 'upload'">
                                            <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="text-align:center">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id" :style="body['isRead'] == '0' ? 'font-weight:600;background: rgba(232, 232, 232, 1)': ''">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions'">
                                        <template v-if="item == 'Subjek'">
                                            <span :title="body['isiSurat']"><span class="font-weight-bold mr-2">{{body['jenisSurat']}}</span>{{body['perihal']}}</span>
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'listLampiran'">
                                                <CRow>
                                                    <CCol sm="6" v-for="(pdf, ids) in body['listLampiran']" :key="ids">
                                                        <img class="mr-2" :src="downloadIcon" @click="direct(id, ids)" width="20px" height="20px" style="cursor:pointer"/>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'urlSurat'">
                                                    <img class="mr-2" :src="downloadIcon" @click="show(id)" width="20px" height="20px" style="cursor:pointer"/>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'statusAction'">
                                                        <span v-if="body['action'] == 'D'">Draft</span>
                                                        <span v-if="body['action'] == 'S' && body['status'] == 'P'">On Progress</span>
                                                        <span v-if="body['action'] == 'S' && body['status'] == 'R'">Rejected</span>
                                                        <span v-if="body['action'] == 'S' && body['status'] == 'S'">Sent</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'dataAksi'">
                                                            {{body['action']}}
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'internal'">
                                                                {{ body['internal'] == '1' ? 'Internal' : 'Eksternal' }}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'isUploaded'">
                                                                    <span class="badge text-white bg-success" v-if="body['isUploaded'] == '2'">Sudah Upload Surat</span>
                                                                    <span class="badge text-white bg-danger" v-else>Belum Upload Surat</span>
                                                                </template>
                                                                <template v-else>
                                                                    {{body[item] == null || body[item] == 'null' ? '-' : body[item] }}
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-if="item == 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                        <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item == 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                        <CButton v-if="body['action'] == 'D'" @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                        <CButton v-if="body['action'] == 'S'" @click="goEdit(id)" class="btn my-1 btn-edit mr-1">Detail</CButton>
                                        <CButton @click="goDelete(id)" class="btn my-1 btn-edit mr-1">Delete</CButton>
                                        <CButton @click="goPreview(id)" class="btn my-1 btn-edit mr-1">Preview</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item != 'act' && item == 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                        <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Action</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item != 'act' && item != 'actions' && item == 'acts' && item != 'disposition' && item != 'dispositions' && item != 'upload'">
                                        <CButton v-if="body['edit'] == 'T'" @click="goEdit(id)" class="btn my-1 btn-edit">View</CButton>
                                        <CButton v-if="body['edit'] == 'Y'" @click="goEdit(id)" class="btn my-1 btn-edit">Action</CButton>
                                        <CButton @click="goPreview(id)" class="btn my-1 btn-edit mr-1">Preview</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item == 'disposition' && item != 'dispositions' && item != 'upload'">
                                        <CButton @click="goEdit(id)" class="btn my-1 btn-edit-disposition">Disposition</CButton>
                                        <CButton @click="goHistory(id)" class="btn my-1 btn-edit mr-1">History</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item == 'dispositions' && item != 'upload'">
                                        <CButton v-if="body['action'] == 'S' && body['internal'] == '1'" @click="goDisposition(id)" class="btn my-1 btn-edit-1">Disposition</CButton>
                                        <CButton v-if="body['action'] == 'D'" @click="goEdit(id)" class="btn my-1 btn-edit-1">Edit</CButton>
                                        <CButton v-if="body['action'] == 'S'" @click="goPreview(id)" class="btn my-1 btn-edit-1 mr-1">Surat (QR Code)</CButton>
                                        <CButton v-if="body['action'] == 'S' && body['internal'] != '1'" @click="goPreviewSignature(id)" class="btn my-1 btn-edit-1 mr-1">Surat (Signature)</CButton>
                                        <CButton v-if="body['action'] == 'S'" @click="goEdit(id)" class="btn my-1 btn-edit-1 mr-1">Detail</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item != 'act' && item != 'actions' && item != 'acts' && item != 'disposition' && item != 'dispositions' && item == 'upload'">
                                        <CButton @click="goEdit(id)" class="btn my-1 btn-edit">Edit</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import {DataApi} from '@/service/DataApi'
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
            downloadIcon: require('@/assets/menu/icon_download_excel.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        goDelete(id) {
            this.$emit('delete', id)
        },
        goDisposition(id) {
            this.$emit('disposition', id)
        },
        goHistory(id) {
            this.$emit('history', id)
        },
        show(id) {
            this.$emit('show', id)
        },
        direct(id, ids) {
            let send = id + '##' + ids
            this.$emit('file', send)
        },
        loadStyle(index) {
            if(index == (this.th.length) - 1 ) {
                return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] + ';' + 'text-align: center'
            } else {
                return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
            }
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorHari(value) {
            if(value == 1) {
                return 'Senin'
            } else if(value == 2) {
                return 'Selasa'
            } else if(value == 3) {
                return 'Rabu'
            } else if(value == 4) {
                return 'Kamis'
            } else if(value == 5) {
                return 'Jumat'
            } else if(value == 6) {
                return 'Sabtu'
            } else if(value == 7) {
                return 'Minggu'
            }
        },
        goPreview(val) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: this.data[val].unix,
                qr: '1'
            }
            DataApi.post("/export/surat/preview", payload , {responseType: 'blob'})
            .then(res => {
                this.$store.state.loadingScreen = false
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                const link = document.createElement('a')
                link.href = url
                let title = this.data[val].jenisSurat + ' - ' + this.data[val].perihal
                link.setAttribute('download', title)
                document.body.appendChild(link)
                link.click()
            })
        },
        goPreviewSignature(val) {
            this.$store.state.loadingScreen = true
            let payload = {
                unix: this.data[val].unix
            }
            DataApi.post("/export/surat/preview", payload , {responseType: 'blob'})
            .then(res => {
                this.$store.state.loadingScreen = false
                let response = res.data
                const url = URL.createObjectURL(new Blob([response], {
                    type: 'application/pdf'
                }))
                const link = document.createElement('a')
                link.href = url
                let title = this.data[val].jenisSurat + ' - ' + this.data[val].perihal
                link.setAttribute('download', title)
                document.body.appendChild(link)
                link.click()
            })
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit-1 {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 150px;
    height: 32px;
    float:right;
}
.btn-edit-1:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 150px;
    height: 32px;
    float:right;
}
.btn-edit-disposition {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 100px;
    height: 32px;
    float:right;
}
.btn-edit-delete {
    border-radius: 4px;
    width: 80px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.btn-edit-disposition:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 100px;
    height: 32px;
    float:right;
}
.btn-edits {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 12px;
    font-weight: 600;
    width: 50px;
    height: 32px;
}
.btn-edits:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 12px;
    font-weight: 600;
    width: 50px;
    height: 32px;
}
</style>